const paramStats = {
  item_addclassskills: 1,
  item_nonclassskill: 1,
  state: 1,
  item_singleskill: 1,
  item_elemskill: 1,
  item_aura: 1,
  item_reanimate: 1,
  item_addskill_tab: 1,

  item_skillonattack: 2,
  item_skillonkill: 2,
  item_skillondeath: 2,
  item_skillonhit: 2,
  item_skillonlevelup: 2,
  item_skillongethit: 2,
  item_charged_skill: 2,

  progressive: 1,
};

export default class StatObject {
  constructor() {
    Object.defineProperty(this, 'sources', {value: {}});
  }

  _addSource(id, value, source) {
    let dst = this.sources[id];
    if (!dst) dst = this.sources[id] = {};
    if (typeof source === "object") {
      for (const sid in source) {
        const amount = Math.min(source[sid], value);
        dst[sid] = (dst[sid] || 0) + amount;
        value -= amount;
        if (!value) break;
      }
    } else {
      dst[source] = (dst[source] || 0) + value;
    }
  }

  add(id, value, param, param2, source) {
    if (!value) return;
    const np = paramStats[id];
    let cur = this[id];
    if (!np) {
      this[id] = (cur || 0) + value;
      if (source) this._addSource(id, value, source);
    } else if (id === 'state') {
      if (!cur) cur = this[id] = {};
      if (!cur[param] || value) {
        cur[param] = value;
        const key = `${id}#${param}`;
        this.sources[key] = null;
        if (source) this._addSource(key, value, source);
      }
    } else {
      if (!cur) cur = this[id] = {};
      if (np > 1) param = `${param}#${param2}`;
      cur[param] = (cur[param] || 0) + value;
      if (source) this._addSource(`${id}#${param}`, value, source);
    }
  }

  multiply(id, factor) {
    if (!this[id]) return;
    this[id] = (this[id] * factor) | 0;
    const source = this.sources[id];
    if (source) {
      for (const id in source) {
        source[id] = Math.round(source[id] * factor);
      }
    }
  }

  copy(src) {
    for (const id in src) {
      let cur = this[id];
      const value = src[id];
      if (typeof value === 'object') {
        if (!cur) cur = this[id] = {};
        for (const param in value) {
          cur[param] = (cur[param] || 0) + value[param];
          const key = `${id}#${param}`;
          if (src.sources[key]) this._addSource(key, value[param], src.sources[key]);
        }
      } else if (typeof value === "number") {
        this[id] = (cur || 0) + value;
        if (src.sources[id]) this._addSource(id, value, src.sources[id]);
      } else if (value) {
        this[id] = value;
      }
    }
  }

  add_func(id, from, cbk) {
    const base = this[id], value = this[from];
    if (!value) return;
    const amount = cbk(value, base || 0);
    if (amount) {
      this[id] = (base || 0) + amount;
      const src = this.sources[from];
      if (src) {
        let dst = this.sources[id];
        if (!dst) dst = this.sources[id] = {};
        for (const id in src) {
          dst[id] = (dst[id] || 0) + Math.round(amount * src[id] / value);
        }
      }
    }
  }

  add_from(id, other, from, cbk) {
    const base = this[id], value = other[from];
    if (!value) return;
    const amount = cbk ? cbk(value, base || 0) : value;
    if (amount) {
      this[id] = (base || 0) + amount;
      const src = other.sources[from];
      if (src) {
        let dst = this.sources[id];
        if (!dst) dst = this.sources[id] = {};
        for (const id in src) {
          dst[id] = (dst[id] || 0) + Math.round(amount * src[id] / value);
        }
      }
    }
  }

  add_percent(id, from) {
    this.add_func(id, from, (value, base) => (base * value / 100) | 0);
  }

  add_perlevel(id, from, level, shift) {
    this.add_func(id, from, value => (value * level) >> shift);
  }

  add_percent_perlevel(id, from, level, shift) {
    this.add_func(id, from, (value, base) => (base * ((value * level) >> shift) / 100) | 0);
  }

  add_direct(id, from, factor=1) {
    this.add_func(id, from, value => value * factor | 0);
  }
}
